import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Toggler.module.scss';

const Toggler = ({ onClick, tag: tagFromProps, selected, disabled, onLabel, offLabel, hideLabel = false, ...extra }) => {
  const { t } = useTranslation();

  const tag = fromAnyToTrimmed(tagFromProps);
  const displayOn = fromAnyToTrimmed(onLabel) || 'composite.toggler.on';
  const displayOff = fromAnyToTrimmed(offLabel) || 'composite.toggler.off';

  const { isDarkMode } = useTheme();

  return (
    <div
      {...extra}
      data-bem="Toggler"
      data-tag={tag}
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={cn({
        [CN.component]: true,
        [CN.isSelected]: selected,
        [CN.isDisabled]: disabled,
        [CN.darkMode]: isDarkMode,
        [CN.noLabel]: hideLabel,
      })}
    >
      <div className={CN.track}>
        <div className={CN.handle} />
      </div>
      {!hideLabel && <div className={CN.label}>{selected ? t(displayOn) : t(displayOff)}</div>}
    </div>
  );
};

export default Toggler;
